import { ReactNode } from 'react';

import { Box } from '@vimeo/bokeh';

interface PaywallCTAsWrapperProps {
  children: ReactNode;
}

export function PaywallCTAsWrapper({ children }: PaywallCTAsWrapperProps) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      position="sticky"
      bottom="0"
      width="100%"
      maxWidth="400px"
      gap="sm"
      alignItems="stretch"
      bg="surface"
      pt="24px"
    >
      {children}
    </Box>
  );
}
